export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-braille-dac75212fe529ce66eefb00d8ec609d0.svg";